
function getFocusableElements(container) {
  if(!container) return []; 
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('blur', this.onBlur.bind(this));
      this.greyOut(this.input);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const max = Number(this.input.max) || Infinity;
    const min = Number(this.input.min) || 1;
    const step = Number(this.input.step) || 1;
    let newValue = Number(previousValue);

    if (event.target.name === 'plus') {
      newValue = Math.min(max, newValue + step);
    } else {
      newValue = Math.max(min, newValue - step);
    }

    // Only update if value changed and is within limits
    if (newValue !== Number(previousValue)) {
      this.input.value = newValue;
      this.input.dispatchEvent(this.changeEvent);
      this.syncAllInputs(this.input);
    }
  }

  onInput(event) {
    this.greyOut(event.target);
  }

  onBlur(event) {
    this.onInputChange(event);
  }

  onInputChange(event) {
    const value = Number(event.target.value);
    const max = Number(event.target.max) || Infinity;
    const min = Number(event.target.min) || 1;
    
    if (isNaN(value)) {
      event.target.value = min;
    } else {
      event.target.value = Math.max(min, Math.min(max, value));
    }
    
    this.syncAllInputs(event.target);
    this.greyOut(event.target);
  }

  syncAllInputs(sourceInput) {
    if (!sourceInput) return;
    const allInputs = document.querySelectorAll('quantity-input input');
    const value = sourceInput.value;

    allInputs.forEach(input => {
      if (input !== sourceInput) {
        input.value = value;
        this.greyOut(input);
      }
    });
  }

  greyOut(input) {
    if (!input) return;
    const value = Number(input.value);
    const max = Number(input.max) || Infinity;
    const min = Number(input.min) || 1;
    const parent = input.closest('quantity-input');
    
    if (!parent) return;

    const btnPlus = parent.querySelector('button[name="plus"]');
    const btnMinus = parent.querySelector('button[name="minus"]');

    if (btnPlus) {
      btnPlus.style.opacity = value >= max ? 0.3 : 1;
      btnPlus.style.pointerEvents = value >= max ? 'none' : 'all';
    }

    if (btnMinus) {
      btnMinus.style.opacity = value <= min ? 0.3 : 1;
      btnMinus.style.pointerEvents = value <= min ? 'none' : 'all';
    }
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
    this.addEventListener("contextmenu", e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.navigator = this.querySelectorAll('button.item-navigator');
    this.initialNavigator = this.querySelector('button.item-navigator.active');
    this.initialSliderItem = this.querySelector('li.active');

    if (!this.initialNavigator) {
      //this.navigator[0].classList.add('active');
    }
    if (this.initialSliderItem) {
      this.slider.scrollTo({
        left: this.initialSliderItem.offsetLeft
      });
    }

    if (!this.slider || !this.nextButton) return;

    this.resizeObserver = new ResizeObserver(entries => this.initPages());
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    for ( let i = 0; i < this.navigator.length; i++){
      this.navigator[i].addEventListener('click', this.onNavigatorClick.bind(this));
    }

    this.slideObserver = new IntersectionObserver(this.imageSlideHandle.bind(this), {threshold: 0.5});
    this.sliderItems.forEach( item => {
      this.slideObserver.observe(item);
    })
  }

  imageSlideHandle(entries){
    entries.forEach( entry => {
      if ( !entry.isIntersecting) return;
      const slideIndex = Array.from(this.sliderItems).indexOf(entry.target);
      if( slideIndex >= 0 ){
        this.navigator.forEach( (item,index) => {
          item.classList.remove("active");
          if( index == slideIndex ){
            item.classList.add("active");
          }
        });
      }
    })
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    // for ( let i = 0; i < this.navigator.length; i++){
    //   this.navigator[i].classList.remove("active");
    // }
    // this.navigator[this.currentPage - 1].classList.add("active");
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onNavigatorClick(event){
    event.preventDefault();
    this.resizeObserver.unobserve(this.slider);
    const clickedPosition = event.currentTarget.dataset.position - 1;
    const itemToShow = this.sliderItems[clickedPosition];
    this.slider.scrollTo({
      left: itemToShow.offsetLeft
    });
    this.pageCount.textContent = clickedPosition;

    for ( let i = 0; i < this.navigator.length; i++){
      this.navigator[i].classList.remove("active");
    }
    event.currentTarget.classList.add("active");
    this.resizeObserver.observe(this.slider);

  }

  handleIntersection(entries,observer){
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

  }
  
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.renderProductInfoRequestId = 0;
    this.renderProductInfoController = null;
    this.productInfoSectionRequestId = 0;
    this.productInfoSectionController = null;
  }

                       
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantInput();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.renderProductInfo();
      this.updateProductInformationSection();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    // buyeeTrigger(this.currentVariant.id);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `li[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    const newNavigator = document.querySelector(
      `.product__media-item-thumbnail[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    const navigator = document.querySelectorAll('.product__media-item-thumbnail');

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    navigator.forEach((e) => {
      e.querySelector('button').classList.remove('active');
    })
    newNavigator.querySelector('button').classList.add('active');
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    const variantRadios = document.querySelector('variant-radios');

    const variantOptionsDefinitions = Array.from(document.querySelectorAll('.variant-options-definitions'));
    const visibleVariantCombinations = variantOptionsDefinitions
      .filter((def) => def.getAttribute('data-visible') !== 'false')
      .map((def) => def.dataset.options.split('||'));
    const selectableVariantCombinations = variantOptionsDefinitions
      .filter((def) => {
        const selectableValue = def.getAttribute('data-selectable');
        if (selectableValue !== null) {
          return selectableValue !== 'false';
        }
        return def.getAttribute('data-inventory') !== 'false';
      })
      .map((def) => def.dataset.options.split('||'));

    if (variantRadios) {
      const optionGroups = variantRadios.querySelectorAll('fieldset.js');
      const selectionAdjusted = this.updateProductOptionAvailability(
        optionGroups,
        visibleVariantCombinations,
        selectableVariantCombinations,
        false,
      );

      if (selectionAdjusted) {
        this.updateOptions();
        this.updateMasterId();
      }

      if (!this.currentVariant || !this.currentVariant.id) {
        return;
      }
    } else {
      if (!this.currentVariant || !this.currentVariant.id) {
        return;
      }
    }

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && this.currentVariant?.id) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }  

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateProductOptionAvailability(
    optionGroups,
    visibleVariantCombinations,
    selectableVariantCombinations = visibleVariantCombinations,
    dispatchSelectionChange = true,
  ) {
    const selectedValues = [];
    let adjustedSelectionInput = null;

    optionGroups.forEach((optionGroup, optionGroupIndex) => {
      const optionRadios = Array.from(optionGroup.querySelectorAll('.variant-radio'));

      // Build the current branch from already-normalized parent selections.
      let filteredVisibleCombinations = visibleVariantCombinations;
      let filteredSelectableCombinations = selectableVariantCombinations;
      for (let i = 0; i < optionGroupIndex; i += 1) {
        if (selectedValues[i] != null) {
          filteredVisibleCombinations = filteredVisibleCombinations
            .filter((combination) => combination[i] === selectedValues[i]);
          filteredSelectableCombinations = filteredSelectableCombinations
            .filter((combination) => combination[i] === selectedValues[i]);
        }
      }

      const visibleCandidateValues = new Set(
        filteredVisibleCombinations
          .map((combination) => combination[optionGroupIndex])
          .filter((value) => value != null && value !== ''),
      );
      const selectableCandidateValues = new Set(
        filteredSelectableCombinations
          .map((combination) => combination[optionGroupIndex])
          .filter((value) => value != null && value !== ''),
      );

      let firstCandidateRadio = null;

      optionRadios.forEach((radio) => {
        const isVisibleCandidate = visibleCandidateValues.has(radio.value);
        const isSelectableCandidate = selectableCandidateValues.has(radio.value);

        if (isVisibleCandidate && !firstCandidateRadio) {
          firstCandidateRadio = radio;
        }

        radio.classList.toggle('hidden', !isVisibleCandidate);
        radio.classList.toggle('disabled', !isVisibleCandidate || !isSelectableCandidate);
        radio.classList.toggle('unavailable', isVisibleCandidate && !isSelectableCandidate && radio.checked);
      });

      let effectiveSelection = optionGroup.querySelector('input.variant-radio:checked');
      const hasValidCheckedSelection = Boolean(
        effectiveSelection && visibleCandidateValues.has(effectiveSelection.value),
      );

      if (!hasValidCheckedSelection) {
        if (firstCandidateRadio && !firstCandidateRadio.checked) {
          firstCandidateRadio.checked = true;
          adjustedSelectionInput = firstCandidateRadio;
        }
        effectiveSelection = firstCandidateRadio || null;
      }

      selectedValues[optionGroupIndex] = effectiveSelection ? effectiveSelection.value : null;

      // Keep upper levels visible; hide only levels that have no candidates in current branch.
      const shouldHideOptionGroup = visibleCandidateValues.size === 0;
      optionGroup.classList.toggle('hidden', shouldHideOptionGroup);
      optionGroup.hidden = shouldHideOptionGroup;
    });

    if (adjustedSelectionInput && dispatchSelectionChange) {
      adjustedSelectionInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return Boolean(adjustedSelectionInput);
  }

  ensureVisibleSelections(variantRadiosElement) {
    if (!variantRadiosElement) return;

    const fieldsets = Array.from(variantRadiosElement.querySelectorAll('fieldset.js'));
    let adjustedSelectionInput = null;

    fieldsets.forEach((fieldset) => {
      const currentSelection = fieldset.querySelector('input.variant-radio:checked');
      const visibleRadios = Array.from(fieldset.querySelectorAll('input.variant-radio:not(.hidden)'));

      if (visibleRadios.length === 0) {
        fieldset.classList.add('hidden');
        fieldset.hidden = true;
        return;
      }

      fieldset.classList.remove('hidden');
      fieldset.hidden = false;
      const nextSelection = visibleRadios[0];
      const selectionIsInvalid = !currentSelection
        || currentSelection.classList.contains('hidden');

      if (selectionIsInvalid && nextSelection && !nextSelection.checked) {
        nextSelection.checked = true;
        adjustedSelectionInput = nextSelection;
      }
    });

    if (adjustedSelectionInput) {
      adjustedSelectionInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  //updates product forms
  renderProductInfo() {
    if (!this.currentVariant?.id) return;

    const requestId = (this.renderProductInfoRequestId || 0) + 1;
    this.renderProductInfoRequestId = requestId;

    if (this.renderProductInfoController) {
      this.renderProductInfoController.abort();
    }

    const hasAbortController = typeof window.AbortController === 'function';
    this.renderProductInfoController = hasAbortController ? new window.AbortController() : null;

    const requestUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const fetchOptions = this.renderProductInfoController ? { signal: this.renderProductInfoController.signal } : undefined;

    fetch(requestUrl, fetchOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Variant section request failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        if (requestId !== this.renderProductInfoRequestId) {
          return;
        }

        //these section gets updated when variant changes
        const ids = [`price-`, // price info
                    `product-form-`, // pdp product form
                    `sticky-form-`, // product form and other info in the buy button below the screen when in mobile
                    `sticky-quantity-selector-`,
                    `product-release-info-`, //release info
                    `product-shipping-info-`, // product shipping info
                    `other-info-`,// additional info: SKU etc
                    `quantity-selector-`,  // quantity selector container
                    `release-info-`,
                  ];

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        ids.forEach( id => {
          id = id + this.dataset.section;
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
          if (source && destination){
            destination.innerHTML = source.innerHTML;
            if( id.includes("form")){
              destination.querySelector("[name=id]").disabled = false;
              //copy data sets
              Object.assign(destination.dataset, source.dataset);
            }
          } 
        });

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        const releaseInfo = document.getElementById(`product-release-info-${this.dataset.section}`);
        if (releaseInfo) releaseInfo.classList.remove('visibility-hidden');

        // disabled button for sales period logic
        const mainForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (mainForm) {
          const mainButtons = mainForm.querySelector('.product-form__buttons');
          if (mainButtons) mainButtons.classList.remove('visibility-hidden');

          const submitButton = mainForm.querySelector('.product-form__submit');
          if (submitButton) {
            const btnDisable = mainForm.dataset.disabled == 'true';
            const btnText = submitButton.textContent.trim();
            this.toggleAddButton(!this.currentVariant.available || btnDisable, btnDisable ? btnText : window.variantStrings.soldOut);
          }
        }

        const stickyForm = document.getElementById(`sticky-form-${this.dataset.section}`);
        const stickyButtons = stickyForm?.querySelector('.product-form__buttons');
        if (stickyButtons) stickyButtons.classList.remove('visibility-hidden');

        //update free shipping info for sticky element
        
        /*
        const shippingInfo = document.getElementById(`product-shipping-info-${this.dataset.section}`);
        const shippingInfoSticky = document.querySelector(".sp-sticky__shipping-info");
        const content = shippingInfo.querySelector(".product__shipping-info");
        if( content ){
          shippingInfoSticky.innerHTML = `
            <div class="shipping-info__content">
              ${content.innerHTML}
            </div>
          `;
        }else{
          shippingInfoSticky.innerHTML = "";
        }
        */

      })
      .catch((error) => {
        if (error?.name === 'AbortError') {
          return;
        }
        console.error('[VariantSelects] renderProductInfo failed:', error);
      });
  }

   //updates product forms
   updateProductInformationSection() {
    if (!this.currentVariant?.id) return;

    const requestId = (this.productInfoSectionRequestId || 0) + 1;
    this.productInfoSectionRequestId = requestId;

    if (this.productInfoSectionController) {
      this.productInfoSectionController.abort();
    }

    const hasAbortController = typeof window.AbortController === 'function';
    this.productInfoSectionController = hasAbortController ? new window.AbortController() : null;

    const requestUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section.replace('__main', '')}__product-information`;
    const fetchOptions = this.productInfoSectionController ? { signal: this.productInfoSectionController.signal } : undefined;

    //const sectionId = "template--16800055263403__main".split("__")[0]+"__product-information";
    fetch(requestUrl, fetchOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Product information section request failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        if (requestId !== this.productInfoSectionRequestId) {
          return;
        }

        //these section gets updated when variant changes
        const ids = ["product-information-contents"]; 

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        ids.forEach( id => {
          id = id;
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
          if (source && destination){
            destination.innerHTML = source.innerHTML;
          }
          
        });

        const collapsibles = document.querySelectorAll('.product-info-collapsible');

        if (collapsibles.length > 0) {
            collapsibles[0].click(); 
        }

      })
      .catch((error) => {
        if (error?.name === 'AbortError') {
          return;
        }
        console.error('[VariantSelects] updateProductInformationSection failed:', error);
      });

  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyForm = document.getElementById(`sticky-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const stickyButton = stickyForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const stickyButtonText = stickyForm.querySelector('[name="add"] > span');

    if (!addButton || !stickyButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      stickyButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
        stickyButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      // addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

document.addEventListener('DOMContentLoaded', () => {
  const getVariantRadios = () => document.querySelector('variant-radios');
  const variantRadios = getVariantRadios();
  if (!variantRadios) return;

  // Initial sync: ensure top-down disabled/hidden classes are computed on first paint.
  // Without this, the first state can remain as rendered by Liquid until first user change.
  if (typeof variantRadios.updateOptions === 'function' &&
      typeof variantRadios.updateMasterId === 'function' &&
      typeof variantRadios.updateVariantInput === 'function') {
    variantRadios.updateOptions();
    variantRadios.updateMasterId();
    variantRadios.updateVariantInput();
  }

  // Initial repaint: on first load, available default variants can still keep
  // Liquid-applied disabled classes until a user-triggered change happens.
  if (typeof variantRadios.updateProductOptionAvailability === 'function') {
    window.requestAnimationFrame(() => {
      if (typeof variantRadios.updateOptions === 'function') {
        variantRadios.updateOptions();
      }

      const initialOptionGroups = variantRadios.querySelectorAll('fieldset.js');
      const initialVariantDefinitions = Array.from(document.querySelectorAll('.variant-options-definitions'));
      const initialVisibleCombinations = initialVariantDefinitions
        .filter((def) => def.getAttribute('data-visible') !== 'false')
        .map((def) => def.dataset.options.split('||'));
      const initialSelectableCombinations = initialVariantDefinitions
        .filter((def) => {
          const selectableValue = def.getAttribute('data-selectable');
          if (selectableValue !== null) {
            return selectableValue !== 'false';
          }
          return def.getAttribute('data-inventory') !== 'false';
        })
        .map((def) => def.dataset.options.split('||'));

      if (initialVisibleCombinations.length > 0) {
        variantRadios.updateProductOptionAvailability(
          initialOptionGroups,
          initialVisibleCombinations,
          initialSelectableCombinations,
        );
      }
    });
  }

  // Keep each option group on a visible selection.
  // When a parent option changes, a lower-level checked value can become hidden.
  const skipHiddenVariants = () => {
    const currentVariantRadios = getVariantRadios();
    if (!currentVariantRadios || typeof currentVariantRadios.ensureVisibleSelections !== 'function') return;
    currentVariantRadios.ensureVisibleSelections(currentVariantRadios);
  };

  // Run on load and whenever variants change
  skipHiddenVariants();
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-radios')) {
      skipHiddenVariants();
    }
  });

  // After all DOMContentLoaded handlers (including smart variant selection),
  // fetch the correct price/button HTML for the resolved variant.
  window.setTimeout(() => {
    const currentVariantRadios = getVariantRadios();
    if (!currentVariantRadios || typeof currentVariantRadios.renderProductInfo !== 'function') return;

    if (typeof currentVariantRadios.updateOptions === 'function') {
      currentVariantRadios.updateOptions();
    }
    if (typeof currentVariantRadios.updateMasterId === 'function') {
      currentVariantRadios.updateMasterId();
    }
    if (currentVariantRadios.currentVariant?.id) {
      currentVariantRadios.renderProductInfo();
    }
  }, 0);
});